"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Carousel_utils_1 = require("./Carousel.utils");
var faChevronLeft_1 = require("@fortawesome/pro-regular-svg-icons/faChevronLeft");
var faChevronRight_1 = require("@fortawesome/pro-regular-svg-icons/faChevronRight");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var resize_observer_1 = require("@juggle/resize-observer");
var Button_1 = __importDefault(require("../Button/Button"));
var react_fast_compare_1 = __importDefault(require("react-fast-compare"));
var react_1 = __importStar(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var react_use_measure_1 = __importDefault(require("react-use-measure"));
var usePrevious_1 = __importDefault(require("../hooks/usePrevious"));
var useWindowUpdateHelper_1 = __importDefault(require("../hooks/useWindowUpdateHelper"));
var Carousel = function (_a) {
    var _b = _a.buttonsOverlayCards, buttonsOverlayCards = _b === void 0 ? false : _b, cards = _a.cards, className = _a.className, _c = _a.extendButtons, extendButtons = _c === void 0 ? false : _c, _d = _a.hideNextButton, hideNextButton = _d === void 0 ? false : _d, _e = _a.hidePreviousButton, hidePreviousButton = _e === void 0 ? false : _e, _f = _a.marginBetweenCards, marginBetweenCards = _f === void 0 ? 20 : _f, minWidth = _a.minWidth, _g = _a.noButtons, noButtons = _g === void 0 ? false : _g, _h = _a.scrollDuration, scrollDuration = _h === void 0 ? 0.5 : _h, _j = _a.scrollFullWidth, scrollFullWidth = _j === void 0 ? false : _j, _k = _a.testid, testid = _k === void 0 ? 'carousel' : _k;
    var scrollAreaRef = (0, react_1.useRef)(null);
    var cardsRefs = (0, react_1.useRef)([]);
    var _l = (0, react_1.useState)(true), isWaitingForRender = _l[0], setIsWaitingForRender = _l[1];
    var _m = (0, react_1.useState)(0), currentScrollPosition = _m[0], setCurrentScrollPosition = _m[1];
    var _o = (0, react_1.useState)(true), isNextButtonActive = _o[0], setIsNextButtonActive = _o[1];
    var _p = (0, react_1.useState)(false), isPreviousButtonActive = _p[0], setIsPreviousButtonActive = _p[1];
    var _q = (0, react_use_measure_1.default)({ polyfill: resize_observer_1.ResizeObserver }), contentRef = _q[0], width = _q[1].width;
    var prevCards = (0, usePrevious_1.default)(cards);
    var forwardBreakpointAdjust = scrollFullWidth ? 0 : 1;
    var getBreakPoints = (0, react_1.useCallback)(function () {
        var points = [0];
        var contentTotalWidth = 0;
        cards.forEach(function (card, index) {
            if (!cardsRefs.current[index]) {
                return;
            }
            var isLastCard = index === cards.length - 1;
            // ref arrays are weird, but the internal array is the elements directly, not the refs
            // @ts-expect-error in addition, it doesn't seem to be noticing the return statement above if current[index] is not defined
            var cardWidth = cardsRefs.current[index].offsetWidth;
            if (isLastCard) {
                contentTotalWidth += cardWidth;
            }
            else {
                contentTotalWidth += cardWidth + marginBetweenCards;
            }
            points.push(contentTotalWidth);
        });
        return points;
    }, [cards, marginBetweenCards]);
    var updateActiveButtons = (0, react_1.useCallback)(function (newScrollToPoint) {
        // ignoring these for coverage as the ref will always be defined in the tests
        /* istanbul ignore if */
        if (!(scrollAreaRef === null || scrollAreaRef === void 0 ? void 0 : scrollAreaRef.current)) {
            /* istanbul ignore next */
            return;
        }
        var breakPoints = getBreakPoints();
        var distanceFromLastScrollPoint = breakPoints[breakPoints.length - 1] - newScrollToPoint;
        setIsPreviousButtonActive(newScrollToPoint > 0);
        setIsNextButtonActive(distanceFromLastScrollPoint > width);
    }, [getBreakPoints, width]);
    (0, react_1.useEffect)(function () {
        updateActiveButtons(currentScrollPosition);
    }, [cards, currentScrollPosition, updateActiveButtons]);
    (0, react_1.useEffect)(function () {
        if ((scrollAreaRef === null || scrollAreaRef === void 0 ? void 0 : scrollAreaRef.current) && isWaitingForRender) {
            updateActiveButtons(0);
            setIsWaitingForRender(false);
        }
    }, [isWaitingForRender, scrollAreaRef, updateActiveButtons]);
    (0, react_1.useEffect)(function () {
        if (!(0, react_fast_compare_1.default)(cards, prevCards) && scrollAreaRef.current) {
            scrollAreaRef.current.scrollLeft = 0;
            setCurrentScrollPosition(0);
            updateActiveButtons(0);
        }
    }, [cards, prevCards, updateActiveButtons]);
    (0, useWindowUpdateHelper_1.default)(function () {
        if ((scrollAreaRef === null || scrollAreaRef === void 0 ? void 0 : scrollAreaRef.current) && !isWaitingForRender) {
            updateActiveButtons(currentScrollPosition);
        }
    });
    var animate = react_1.default.useCallback(function (callbackObj) {
        // ignoring this for coverage because it's browser-specific behavior
        /* istanbul ignore next */
        var requestAnimationFrame = window.requestAnimationFrame ||
            // @ts-expect-error Apple requestAnimationFrame
            window.webkitRequestAnimationFrame ||
            // @ts-expect-error FireFox requestAnimationFrame
            window.mozRequestAnimationFrame ||
            // @ts-expect-error Opera(?) requestAnimationFrame
            window.oRequestAnimationFrame ||
            // @ts-expect-error IE/Edge requestAnimationFrame
            window.msRequestAnimationFrame;
        var animationTime = 0;
        var percentage = 0;
        var startTime = 0;
        var duration = scrollDuration * 1000;
        var animation = function (timestamp) {
            if (startTime === 0) {
                startTime = timestamp;
            }
            else {
                animationTime = Math.floor(timestamp - startTime);
            }
            if (animationTime <= duration) {
                percentage = animationTime / duration;
                callbackObj.progress(percentage);
                requestAnimationFrame(animation);
            }
        };
        return requestAnimationFrame(animation);
    }, [scrollDuration]);
    var scroll = react_1.default.useCallback(function (scrollToPoint) {
        var sequenceObj = {};
        var distance = scrollToPoint - currentScrollPosition;
        sequenceObj.progress = function (percentage) {
            var newPosition = currentScrollPosition + (0, Carousel_utils_1.easeQuadInOut)(percentage) * distance;
            newPosition = distance < 0 && newPosition < 25 ? 0 : newPosition;
            // ignoring this for coverage as the ref will always be defined in the tests
            /* istanbul ignore else */
            if (scrollAreaRef === null || scrollAreaRef === void 0 ? void 0 : scrollAreaRef.current) {
                scrollAreaRef.current.scrollLeft = newPosition;
            }
        };
        animate(sequenceObj);
    }, [animate, currentScrollPosition]);
    var getClosestBreakPointIndex = (0, react_1.useCallback)(function (actualBreakPoint) {
        var breakPoints = getBreakPoints();
        var closestBreakPoint = breakPoints.reduce(function (closestBreakPoint, breakPoint) {
            var currentBreakPointDistance = Math.abs(actualBreakPoint - breakPoint);
            var closestBreakPointDistance = Math.abs(actualBreakPoint - closestBreakPoint);
            if (currentBreakPointDistance < closestBreakPointDistance) {
                return breakPoint;
            }
            return closestBreakPoint;
        }, Infinity);
        return breakPoints.indexOf(closestBreakPoint);
    }, [getBreakPoints]);
    var goToPreviousPage = react_1.default.useCallback(function (event) {
        // ignoring these for coverage as the ref will always be defined in the tests
        /* istanbul ignore if */
        if (!(scrollAreaRef === null || scrollAreaRef === void 0 ? void 0 : scrollAreaRef.current)) {
            /* istanbul ignore next */
            return;
        }
        // in case carousel is wrapped in a link, we want to ignore those events
        event.stopPropagation();
        event.preventDefault();
        var closestCurrentBreakPointIndex = getClosestBreakPointIndex(currentScrollPosition);
        var breakPoints = getBreakPoints();
        var adjustedPosition = breakPoints[closestCurrentBreakPointIndex] - scrollAreaRef.current.offsetWidth;
        var newScrollToPointIndex = getClosestBreakPointIndex(adjustedPosition);
        // This is to prevent scrolling over unseen cards
        var isScrollingPastViewArea = Math.abs(currentScrollPosition - breakPoints[newScrollToPointIndex]) >
            scrollAreaRef.current.offsetWidth;
        // In order to show as many whole cards as possible, the scrolling amount will be reduced when the arrows overlay the cards
        var isScrollingWithButtonOverlay = buttonsOverlayCards && closestCurrentBreakPointIndex - newScrollToPointIndex > 1;
        if ((isScrollingPastViewArea || isScrollingWithButtonOverlay) && !scrollFullWidth) {
            newScrollToPointIndex += 1;
        }
        var newScrollToPoint = breakPoints[newScrollToPointIndex];
        setCurrentScrollPosition(newScrollToPoint);
        updateActiveButtons(newScrollToPoint);
        scroll(newScrollToPoint);
    }, [
        buttonsOverlayCards,
        currentScrollPosition,
        getBreakPoints,
        getClosestBreakPointIndex,
        scroll,
        scrollFullWidth,
        updateActiveButtons,
    ]);
    var goToNextPage = react_1.default.useCallback(function (event) {
        // ignoring these for coverage as the ref will always be defined in the tests
        /* istanbul ignore if */
        if (!(scrollAreaRef === null || scrollAreaRef === void 0 ? void 0 : scrollAreaRef.current)) {
            /* istanbul ignore next */
            return;
        }
        // in case carousel is wrapped in a link, we want to ignore those events
        event.stopPropagation();
        event.preventDefault();
        var closestCurrentBreakPointIndex = getClosestBreakPointIndex(currentScrollPosition);
        var breakPoints = getBreakPoints();
        var adjustedPosition = breakPoints[closestCurrentBreakPointIndex] + scrollAreaRef.current.offsetWidth;
        var newScrollToPointIndex = getClosestBreakPointIndex(adjustedPosition) - forwardBreakpointAdjust;
        // This is to prevent scrolling over unseen cards
        var isScrollingPastViewArea = Math.abs(breakPoints[newScrollToPointIndex] - currentScrollPosition) >
            scrollAreaRef.current.offsetWidth;
        // In order to show as many whole cards as possible, the scrolling amount will be reduced when the arrows overlay the cards
        var isScrollingWithButtonOverlay = buttonsOverlayCards && newScrollToPointIndex - closestCurrentBreakPointIndex > 1;
        if ((isScrollingPastViewArea || isScrollingWithButtonOverlay) && !scrollFullWidth) {
            newScrollToPointIndex -= 1;
        }
        var newScrollToPoint = breakPoints[newScrollToPointIndex];
        setCurrentScrollPosition(newScrollToPoint);
        updateActiveButtons(newScrollToPoint);
        scroll(newScrollToPoint);
    }, [
        buttonsOverlayCards,
        currentScrollPosition,
        forwardBreakpointAdjust,
        getBreakPoints,
        getClosestBreakPointIndex,
        scroll,
        scrollFullWidth,
        updateActiveButtons,
    ]);
    var carouselCards = (0, react_1.useMemo)(function () {
        return cards.map(function (card, index) {
            var _a;
            if (!card) {
                return card;
            }
            var isLastCard = index === cards.length - 1;
            var spacingMargin = isLastCard ? '' : "".concat(marginBetweenCards, "px");
            // ideally, the cards that get passed in should have a key assigned to them
            return (react_1.default.createElement("span", { "data-testid": "carouselCard", key: index, ref: function (ref) { return cardsRefs.current.push(ref); }, style: __assign(__assign({}, (spacingMargin && { marginRight: spacingMargin })), { width: ((_a = card.props.style) === null || _a === void 0 ? void 0 : _a.width) || 'fit-content' }) }, card));
        });
    }, [cards, marginBetweenCards]);
    return (react_1.default.createElement(StyledCarousel, { "$isOverlapping": buttonsOverlayCards || extendButtons, "$minWidth": minWidth, className: className, "data-testid": testid, ref: contentRef },
        noButtons || (hidePreviousButton && !buttonsOverlayCards && !isPreviousButtonActive) ? null : (react_1.default.createElement(StyledButtonBox, { "$extendButtons": extendButtons },
            react_1.default.createElement(StyledArrowButton, { "$hideOnOverlap": !isPreviousButtonActive && buttonsOverlayCards && hidePreviousButton, "$isOverlapping": buttonsOverlayCards && !extendButtons, "aria-label": "advance carousel backwards button", disabled: !isPreviousButtonActive, onClick: goToPreviousPage, secondary: true, testid: "carousel-previous-button" },
                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: faChevronLeft_1.faChevronLeft })))),
        react_1.default.createElement(StyledChildrenBox, { ref: scrollAreaRef }, carouselCards),
        noButtons || (hideNextButton && !buttonsOverlayCards && !isNextButtonActive) ? null : (react_1.default.createElement(StyledButtonBox, { "$extendButtons": extendButtons, "$isNext": true },
            react_1.default.createElement(StyledArrowButton, { "$hideOnOverlap": !isNextButtonActive && buttonsOverlayCards && hideNextButton, "$isNext": true, "$isOverlapping": buttonsOverlayCards && !extendButtons, "aria-label": "advance carousel forwards button", disabled: !isNextButtonActive, onClick: goToNextPage, secondary: true, testid: "carousel-next-button" },
                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: faChevronRight_1.faChevronRight }))))));
};
exports.default = Carousel;
var StyledCarousel = styled_components_1.default.section(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    position: relative;\n    max-width: 100%;\n    margin-top: 16px;\n    ", "\n    ", "\n"], ["\n    position: relative;\n    max-width: 100%;\n    margin-top: 16px;\n    ", "\n    ", "\n"])), function (_a) {
    var $isOverlapping = _a.$isOverlapping;
    return !$isOverlapping && (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n            padding-left: 60.5px;\n            padding-right: 60.5px;\n        "], ["\n            padding-left: 60.5px;\n            padding-right: 60.5px;\n        "])));
}, function (_a) {
    var $minWidth = _a.$minWidth;
    return $minWidth && (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n            min-width: ", ";\n        "], ["\n            min-width: ", ";\n        "])), $minWidth);
});
var StyledArrowButton = (0, styled_components_1.default)(Button_1.default)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    font-size: 25px;\n    margin-top: auto;\n    margin-bottom: auto;\n    padding-left: 16px;\n    padding-right: 16px;\n    border: none;\n    color: ", ";\n    height: 100%;\n    transition: all 0.25s ease-in;\n    ", "\n\n    &:hover {\n        background-color: ", ";\n        &:enabled {\n            cursor: pointer;\n            color: ", ";\n        }\n        &:disabled {\n            color: ", ";\n            cursor: default;\n        }\n    }\n"], ["\n    font-size: 25px;\n    margin-top: auto;\n    margin-bottom: auto;\n    padding-left: 16px;\n    padding-right: 16px;\n    border: none;\n    color: ", ";\n    height: 100%;\n    transition: all 0.25s ease-in;\n    ", "\n\n    &:hover {\n        background-color: ", ";\n        &:enabled {\n            cursor: pointer;\n            color: ", ";\n        }\n        &:disabled {\n            color: ", ";\n            cursor: default;\n        }\n    }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.blue100;
}, function (_a) {
    var $hideOnOverlap = _a.$hideOnOverlap, $isOverlapping = _a.$isOverlapping, theme = _a.theme;
    var opacity = 1;
    if ($isOverlapping && $hideOnOverlap) {
        opacity = 0;
    }
    else if ($isOverlapping && !$hideOnOverlap) {
        opacity = 0.87;
    }
    return (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n            background-color: ", ";\n            opacity: ", ";\n\n            &:disabled {\n                color: ", ";\n            }\n            &:hover {\n                opacity: ", ";\n            }\n        "], ["\n            background-color: ", ";\n            opacity: ", ";\n\n            &:disabled {\n                color: ", ";\n            }\n            &:hover {\n                opacity: ", ";\n            }\n        "])), $isOverlapping ? theme.colors.white : 'transparent', opacity, theme.colors.grey400, $isOverlapping ? 0.87 : 1);
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.green200;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.blue200;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.grey400;
});
var StyledButtonBox = styled_components_1.default.div(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    position: absolute;\n    z-index: 1; // ensure that the buttons appear on top of the scroll area\n    height: 100%;\n    top: 0;\n    ", "\n    ", "\n"], ["\n    position: absolute;\n    z-index: 1; // ensure that the buttons appear on top of the scroll area\n    height: 100%;\n    top: 0;\n    ", "\n    ", "\n"])), function (_a) {
    var $isNext = _a.$isNext;
    return $isNext
        ? (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n                  right: 0;\n              "], ["\n                  right: 0;\n              "]))) : (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n                  left: 0;\n              "], ["\n                  left: 0;\n              "])));
}, function (_a) {
    var $extendButtons = _a.$extendButtons, $isNext = _a.$isNext;
    if ($extendButtons) {
        return $isNext
            ? (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n                      right: -60.5px;\n                  "], ["\n                      right: -60.5px;\n                  "]))) : (0, styled_components_1.css)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n                      left: -60.5px;\n                  "], ["\n                      left: -60.5px;\n                  "])));
    }
});
var StyledChildrenBox = styled_components_1.default.div(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    display: flex;\n    overflow-x: scroll;\n    overflow-y: hidden;\n\n    // hide scrollbar\n    &::-webkit-scrollbar {\n        display: none; // all browsers except firefox\n    }\n\n    scrollbar-width: none; // firefox\n"], ["\n    display: flex;\n    overflow-x: scroll;\n    overflow-y: hidden;\n\n    // hide scrollbar\n    &::-webkit-scrollbar {\n        display: none; // all browsers except firefox\n    }\n\n    scrollbar-width: none; // firefox\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11;
